import React, {useContext} from 'react';
import {CfPreviewContext} from '@teaser/scripts/components/CfPreviewContext.jsx';
import classNames from 'classnames';

export function XRay({contentType, entryId, fieldId, className}) {
    const previewContext = useContext(CfPreviewContext);
    if (!previewContext || !previewContext.xrayModeEnabled) {
        return;
    }
    if (!contentType) {
        contentType = previewContext.contentType;
    }
    if (!entryId) {
        entryId = previewContext.entryId;
    }

    const href = `https://app.eu.contentful.com/spaces/${previewContext.space}/environments/${previewContext.environment}/entries/${entryId}?focusedField=${fieldId}&focusedLocale=${previewContext.locale}`;
    const title = `Open this ${contentType} in the Contentful editor`;
    return (
        <a className={classNames('contentful-xray-mode-label', className)} href={href} title={title}>
            {fieldId} | {contentType}
        </a>
    );
}
